import React from 'react';
import { Form, Input, Typography } from 'antd';
import { useFFEStore } from '../../store/ffeStore';
import { useCompanyStore } from '../../store/company/companyStore';

const { Title } = Typography;

export const CompanyDetails: React.FC = () => {
  const settings = useFFEStore(state => state.document.purchaseOrderSettings);
  const updateSettings = useFFEStore(state => state.updatePurchaseOrderSettings);
  const company = useCompanyStore(state => state.company);
  const  patchSettings = useCompanyStore((state) => state.patchSettings)

  return (
    <div>
      <Title level={5}>Company Details</Title>
      
      <Form layout="vertical">
        <Form.Item label="Tax/GST Number">
          <Input
            value={company.settings.taxNumber}
            onChange={e => patchSettings({
              taxNumber: e.target.value,
            })}
            placeholder="Enter your tax/GST number"
          />
        </Form.Item>

        <Form.Item label="Contact Name">
          <Input
            value={settings?.contact.name}
            onChange={e => updateSettings({
              ...settings,
              contact: {
                ...settings.contact,
                name: e.target.value,
              },
            })}
            placeholder="Enter contact name"
          />
        </Form.Item>

        <Form.Item label="Contact Email">
          <Input
            value={settings?.contact.email}
            onChange={e => updateSettings({
              ...settings,
              contact: {
                ...settings.contact,
                email: e.target.value,
              },
            })}
            placeholder="Enter contact email"
          />
        </Form.Item>

        <Form.Item label="Contact Phone">
          <Input
            value={settings?.contact.phone}
            onChange={e => updateSettings({
              ...settings,
              contact: {
                ...settings.contact,
                phone: e.target.value,
              },
            })}
            placeholder="Enter contact phone"
          />
        </Form.Item>
      </Form>
    </div>
  );
};